import { render } from "./2FA.vue?vue&type=template&id=1d91d918&scoped=true"
import script from "./2FA.vue?vue&type=script&lang=js"
export * from "./2FA.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=1d91d918&scoped=true&lang=css"

import exportComponent from "D:\\archive\\my8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d91d918"]])

export default __exports__